import React from "react";
import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from "primereact/multiselect";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";

const CustomerSubmitSection = ({
	availableDrivers,
	selectedDrivers,
	setSelectedDrivers,
	availableCollectors,
	selectedCollectors,
	setSelectedCollectors,
	shipmentComment,
	setShipmentComment,
	isEditMode,
	isCreatingShipment,
	handleCreateShipment,
}) => {
	const getDriverOptions = () => {
		return availableDrivers.map((driver) => ({
			value: driver.id,
			label: driver.name,
		}));
	};

	const getCollectorOptions = () => {
		return availableCollectors.map((collector) => ({
			value: collector.id,
			label: collector.name,
		}));
	};

	const handleDriverChange = (e) => {
		setSelectedDrivers(e.value);
	};

	const handleCollectorChange = (e) => {
		setSelectedCollectors(e.value);
	};

	const handleCommentChange = (e) => {
		setShipmentComment(e.target.value);
	};

	const getMultiSelectClassName = () => {
		return `border h-[46px] pt-[2px] w-[20em] max-w-[40em] ${
			selectedCollectors.length ? `w-full` : ""
		}`;
	};

	return (
		<div className="flex items-center gap-4 py-4">
			<Dropdown
				options={getDriverOptions()}
				onChange={handleDriverChange}
				value={selectedDrivers}
				placeholder="Шафёрни танлаш"
				className="w-[20em] border h-[46px] pt-[2px]"
			/>

			<MultiSelect
				options={getCollectorOptions()}
				onChange={handleCollectorChange}
				value={selectedCollectors}
				placeholder="Йиғувчиларни танлаш"
				className={getMultiSelectClassName()}
				display="chip"
			/>

			<InputText
				value={shipmentComment}
				onChange={handleCommentChange}
				placeholder="Izoh"
				className="w-[12em] py-2 pt-3 pl-2 border"
			/>

			<div className="flex items-center justify-end w-full">
				<Button
					label={isEditMode ? "Ўзгартириш" : "Жўнатиш"}
					className="px-5 min-w-[100px] text-white bg-blue rounded-md hover:bg-opacity-90 py-3 mr-6"
					onClick={handleCreateShipment}
					loading={isCreatingShipment}
					disabled={isCreatingShipment}
				/>
			</div>
		</div>
	);
};

export default CustomerSubmitSection;
